export const UPDATE_GENERAL_BOARD_SUB_FILTER_ACTION_SUBJECT = 'updateBoardSubFilter';
export const UPDATE_GENERAL_BOARD_SUB_FILTER_METRICS_KEY = 'update-board-sub-filter';
